import { useEffect, useRef } from 'react';

/**
 * Injects a JSON-LD <script> tag into <head> on mount,
 * removes it on unmount. Works with react-helmet-async v2
 * which does not support inline script children.
 */
export default function JsonLd({ data }) {
  const ref = useRef(null);
  const json = JSON.stringify(data);

  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = json;
    document.head.appendChild(script);
    ref.current = script;
    return () => {
      if (ref.current && document.head.contains(ref.current)) {
        document.head.removeChild(ref.current);
      }
    };
  }, [json]);

  return null;
}
